import { render } from "./DownloadJobs.vue?vue&type=template&id=9b0135f4"
import script from "./DownloadJobs.vue?vue&type=script&lang=js"
export * from "./DownloadJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__